export default __webpack_public_path__ + "static/media/interdisciplinaryapproach.48a1d4c6.png";